import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { MODAL_COUNT_KEY, Poll, PollResults } from '@app/entity/poll';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PollService } from '@app/core/services/poll.service';
import { CookieService } from 'ngx-cookie';

@Component({
  selector: 'app-poll-modals',
  templateUrl: './poll-modals.component.html',
  styleUrls: ['./poll-modals.component.scss']
})

export class PollModalsComponent implements OnInit {
  poll: Poll;

  form: FormGroup;
  private apiErrors = {};
  isOtherActive = false;

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private pollService: PollService,
    private cookieService: CookieService,
  ) {}

  ngOnInit() {
    if (!this.form) this.createForm();
  }

  submit() {
    const pollResults: PollResults = {};
    pollResults.poll = this.poll.id;
    pollResults.answers = [1, 2, 3, 4, 5].filter(answerId => this.form.value[answerId]);
    pollResults.custom_answer = this.form.value['other'];
    this.sendResults(pollResults);
  }

  private setModalCount(count) {
    this.cookieService.put(MODAL_COUNT_KEY, count);
  }

  private getModalCount(): number {
    return +this.cookieService.get(MODAL_COUNT_KEY);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      1: [false, ],
      2: [false, ],
      3: [false, ],
      4: [false, ],
      5: [false, ],
      other: ['', ],
    });
  }

  sendResults(results: PollResults) {
    this.pollService.sendResults(results)
      .subscribe(() => {
        this.bsModalRef.hide();
        this.setModalCount(this.getModalCount() + 1);
    }, error => {
      this.apiErrors = error.error;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/poll-modals/poll-modals.component.ts